import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="clean-footer">
            <div className="footer-container">
                <div className="footer-brand-section">
                    <h2 className="footer-logo">The Rent Company</h2>
                    <p className="footer-description">
                        Discover rental properties tailored to your lifestyle. We connect discerning tenants with exclusive urban retreats and suburban sanctuaries.
                    </p>
                    <div className="footer-contact-list">
                        <a href="tel:+919620981400">+91 96209 81400</a>
                        <a href="tel:+916366699999">+91 63666 99999</a>
                        <span>Support Hours: 10:00 AM to 10:00 PM</span>
                    </div>
                    <div className="social-links">
                        <a href="https://instagram.com" className="social-icon" aria-label="Instagram" target="_blank" rel="noreferrer">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                        </a>
                        <a href="https://x.com" className="social-icon" aria-label="Twitter" target="_blank" rel="noreferrer">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
                        </a>
                        <a href="https://linkedin.com" className="social-icon" aria-label="LinkedIn" target="_blank" rel="noreferrer">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
                        </a>
                    </div>
                </div>

                <div className="footer-links-container">
                    <div className="footer-column">
                        <h3>Company</h3>
                        <Link to="/about">About Us</Link>
                        <Link to="/how-it-works">How It Works</Link>
                        <Link to="/contact">Contact</Link>
                        <Link to="/search">Browse Listings</Link>
                    </div>

                    <div className="footer-column">
                        <h3>Legal</h3>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                        <Link to="/about">About The Rent Company</Link>
                        <Link to="/contact">Support</Link>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} The Rent Company. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
